/** @jsx isolateComponent */
import { Fragment } from 'react';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Colors, Heading, Typography } from '@zapier/design-system';
import DocLinks from '@zapier/product-get-help/esm/components/shared/DocLinks';
const Styles = {
    title: Object.assign(Object.assign({}, Typography.paragraph1ShortBold), { color: Colors.gray }),
};
/** Renders the list of general docs in `<DocsStep>`. */
const GeneralDocs = ({ links }) => (isolateComponent(Fragment, null,
    isolateComponent(Heading, { css: Styles.title },
        links.length === 1 ? 'This article' : 'These articles',
        " may also be useful"),
    isolateComponent(DocLinks, { links: links })));
export default GeneralDocs;
